import React, { PropsWithChildren } from 'react'

import { Stack, StackProps } from '@affstore-ds/uikit'

import { PAGE_VERTICAL_PADDING } from '../../constants/spaces'

/**
 * This component should be uses as wrapper on `pages` layer
 * Do not use it with internal components/containers and other layers instead of `pages` layer
 */
export const PageStaticStack = ({ children, ...rest }: PropsWithChildren<StackProps>) => (
  <Stack gap={24} maw={960} py={PAGE_VERTICAL_PADDING} w="100%" {...rest}>
    {children}
  </Stack>
)
